import guardFace from './guardFace.js';
import paulFace from './paulFace.js';

export default {
  guardFace,
  paulFace
};
